import React from 'react';
import { H5, Optional, Markdown } from '@honda-canada/design-system-react';
import themeStyles from './StaticNumberChart.styles';
import { getTitleComponent, stripMarkdownHeading, styledCompiler } from '../../../utils/markdown';
var StaticNumberChart = function (_a) {
    var chartValue = _a.chartValue, chartBodyText = _a.chartBodyText, chartTitle = _a.chartTitle;
    var TextContainer = themeStyles.apply('div', 'TextContainer');
    var TitleComponent = getTitleComponent(chartTitle, H5);
    var GraphicContainer = themeStyles.apply('div', 'GraphicContainer');
    var ItemContainer = themeStyles.apply('div', 'ItemContainer');
    var StaticNumberContainer = themeStyles.apply('div', 'StaticNumberContainer');
    var ValueTextContainer = themeStyles.apply('div', 'ValueTextContainer');
    var ValueText = themeStyles.apply('text', 'ValueText');
    var BodyTextContainer = themeStyles.apply('div', 'BodyTextContainer');
    return (React.createElement(GraphicContainer, { className: "graphic-container static-number", "data-testid": "graphic-container" },
        React.createElement(ItemContainer, { className: "item-container", "data-testid": "item-container" },
            React.createElement(StaticNumberContainer, { "data-testid": "static-number-container" },
                React.createElement(ValueTextContainer, { "data-testid": "value-text-container" },
                    React.createElement(ValueText, null, chartValue))),
            React.createElement(TextContainer, { "data-testid": "text-container" },
                React.createElement(Optional, { when: chartTitle },
                    React.createElement(TitleComponent, { "data-testid": "chart-title" }, styledCompiler(stripMarkdownHeading(chartTitle)))),
                React.createElement(Optional, { when: chartBodyText },
                    React.createElement(BodyTextContainer, null,
                        React.createElement(Markdown, null, chartBodyText)))))));
};
export default StaticNumberChart;
